import React, { FC, useEffect, useState } from 'react';

// Types
import { UserRole } from 'types/user';

// Store
import profileStore from 'stores/ProfileStore';

// Components
import ButtonView, { ButtonType } from '../ButtonView/ButtonView';
import TabsView from '../Tabs/TabsView';

// Styles
import classes from './TitleManagementPages.module.scss';

interface PageTableViewProps {
  title: string;
  buttonLabel: string;
  buttonType: ButtonType;
  placeholder: string;
  isPlanner?: boolean;
  tabs: string[];
  activeTab: number;
  setActiveTab: (newActiveTab: number) => void;
}

const TitleManagementPages: FC<PageTableViewProps> = ({
  title,
  buttonLabel,
  buttonType,
  placeholder,
  isPlanner,
  tabs,
  activeTab,
  setActiveTab
}) => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [hasManagement, setHasManagment] = useState(false);
  useEffect(() => {
    setHasManagment(
      [
        UserRole.ADMIN.toString(),
        UserRole.MANAGER.toString(),
        UserRole.OWNER.toString()
      ].includes(profileStore.role)
    );
  }, [profileStore.role]);

  return (
    <div className={classes.wrapper}>
      <div className={classes.titleContainer}>
        <div className={classes.title}>{title}</div>
        <div
          className={classes.button}
          style={{ display: !hasManagement ? 'none' : 'inherit' }}
        >
          <ButtonView
            type={buttonType}
            label={buttonLabel}
            isButtonClick={modalIsOpen}
            setIsButtonClick={setModalIsOpen}
          />
        </div>
      </div>
      <TabsView
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        placeholder={placeholder}
        tabs={tabs}
        isPlanner={isPlanner}
      />
    </div>
  );
};

export default TitleManagementPages;
